import { useState } from 'react';
import { useAppSelector } from '../../../store/store';
import CampAlliesInfo from './CampAlliesInfo/CampAlliesInfo';
import CampAlliesList from './CampAlliesList';

const CampAlliesContent = () => {
    const allies = useAppSelector(state => state.campReducer.allies)

    const [isInfo, setIsInfo] = useState(false)

    const haveNotAlly = allies.length === 0 ? (<p className="camp-allies__no-one">You haven't found any ally yet</p>) : null

    return (
        <div className="camp-allies__content">
            <CampAlliesList isInfo={isInfo} openInfo={() => setIsInfo(true)} />
            {isInfo && <CampAlliesInfo />}
            {haveNotAlly}
        </div>
    );
};

export default CampAlliesContent;